export type BulkAction = { label: string; onClick(): void; tone?: "danger" };

export function BulkActionsBar({
  count,
  actions,
  onClear,
}: {
  count: number;
  actions: BulkAction[];
  onClear(): void;
}) {
  if (count === 0) return null;
  return (
    <div
      className="d-flex flex-wrap align-items-center gap-2 border rounded bg-body px-3 py-2 mb-3"
      role="region"
      aria-label="Ações em lote"
    >
      <strong>
        {count} {count === 1 ? "selecionado" : "selecionados"}
      </strong>
      {actions.map((a) => (
        <button
          key={a.label}
          type="button"
          className={`btn btn-sm ${a.tone === "danger" ? "btn-outline-danger" : "btn-outline-primary"}`}
          onClick={a.onClick}
        >
          {a.label}
        </button>
      ))}
      <button type="button" className="btn btn-sm btn-link ms-auto" onClick={onClear}>
        Limpar seleção
      </button>
    </div>
  );
}
